import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IMachine,
    MachineType,
} from '@models';
import {
    ODataFilterProperty,
    ODataQueryOptions,
} from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { ISuggestValues } from '@uipath/angular/components/ui-suggest';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MachineService extends ODataService<IMachine, number> {
    protected _endpoint = '/odata/Machines';
    constructor(http: HttpClient) {
        super(http, MapperService.machineMap);
    }

    public deleteBulk(keys: number[]) {
        const payload = JSON.stringify({ 'machineIds': keys });

        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.DeleteBulk`, payload);
    }

    public machineNameSuggest = (
        searchTerm: string = '',
        fetchSize = 20,
        skip = 0,
        machineType?: MachineType,
    ): Observable<ISuggestValues<IMachine>> => {
        const queryOptions: ODataQueryOptions = {
            select: ['Id', 'Name'],
            orderBy: ['Name'],
            skip: skip,
            top: fetchSize,
            filter: {
                'Name': {
                    contains: searchTerm,
                },
            },
        };

        if (machineType != null) {
            (queryOptions.filter as ODataFilterProperty)['Type'] = MachineType[machineType];
        }

        return this
            .get(queryOptions)
            .pipe(
                map(res => ({
                    total: res.total,
                    data: res.data.map(
                        machine => ({
                            id: machine.id,
                            text: machine.name,
                        }),
                    ),
                } as ISuggestValues<IMachine>),
                ),
            );
    }
}
